import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAbas } from './AbasContexto';
import { cn } from '../../../lib/utils';

/* ============================================================================
   Barra das telas abertas.

   Só desenha. A lista de abas, o cache das telas montadas e a regra de para onde
   ir ao fechar vivem no AbasContexto - que fica acima das rotas, porque precisa
   sobreviver a qualquer remontagem do layout.

   As telas ficam MONTADAS ao trocar de aba (ver AbasContexto): clicar aqui nao
   recarrega nada, so troca qual esta visivel.
   ============================================================================ */

export default function BarraAbas() {
  const { pathname } = useLocation();
  const navegar = useNavigate();
  const { abas, fechar, destinoAoFechar } = useAbas();

  if (!abas.length) return null;

  const aoFechar = (caminho: string) => {
    // Calcula o destino ANTES de fechar: depois a aba nao esta mais na lista e
    // nao ha como saber quem era a vizinha dela.
    const destino = caminho === pathname ? destinoAoFechar(caminho) : null;
    fechar(caminho);
    if (destino) navegar(destino);
  };

  return (
    <div
      role="tablist"
      aria-label="Telas abertas"
      /* Mesmo container das telas (`mx-auto max-w-[var(--gps-pagina-max)] px-6`):
         o <main> nao tem padding lateral - cada tela poe o seu -, e sem isto a
         barra encostaria na borda da janela, desalinhada do titulo logo abaixo. */
      className="mx-auto flex w-full max-w-[var(--gps-pagina-max)] items-stretch gap-1 overflow-x-auto border-b border-line px-4"
    >
      {abas.map((aba) => {
        const ativa = aba.caminho === pathname;

        return (
          <div
            key={aba.caminho}
            /* A linha fica no CONTAINER e nao no botao: o "x" e um segundo botao ao
               lado, e a linha precisa passar por baixo dos dois como uma aba so. */
            className={cn(
              '-mb-px flex flex-none items-center border-b-2 transition-colors',
              ativa ? 'border-primary' : 'border-transparent hover:border-line'
            )}
          >
            <button
              type="button"
              role="tab"
              aria-selected={ativa}
              onClick={() => navegar(aba.caminho)}
              /* Botao do meio fecha, como em navegador. `onAuxClick` e o evento
                 certo - `onClick` nao dispara para o botao do meio. */
              onAuxClick={(e) => {
                if (e.button === 1) {
                  e.preventDefault();
                  aoFechar(aba.caminho);
                }
              }}
              className={cn(
                'max-w-[220px] truncate py-1.5 pl-3 pr-1 text-[12px] transition-colors',
                ativa ? 'font-bold text-primary' : 'font-semibold text-muted-foreground hover:text-ink'
              )}
              title={aba.rotulo}
            >
              {aba.rotulo}
            </button>

            <button
              type="button"
              onClick={() => aoFechar(aba.caminho)}
              aria-label={`Fechar ${aba.rotulo}`}
              title="Fechar"
              className={cn(
                'mr-1 grid h-5 w-5 flex-none place-items-center rounded text-[14px] leading-none transition-colors',
                ativa
                  ? 'text-primary hover:bg-primary hover:text-primary-foreground'
                  : 'text-faint hover:bg-surface-2 hover:text-ink'
              )}
            >
              ×
            </button>
          </div>
        );
      })}
    </div>
  );
}
